<template>
  <div style="height: 100%" @click.stop="searchKeyword = ''">
    <!-- 
    燃爆学堂组件 - 优化版本
    支持一个班级多个课时的功能：
    1. 班级选择后自动加载该班级的所有课时
    2. 课时下拉筛选，支持选择不同的课时时段
    3. 兼容旧数据结构，确保向后兼容
    4. 实时更新选中课时的相关数据（签到、学生信息等）
    -->
    <img class="attendance-bg" src="../assets/images/new_bg.png" alt="" />
    <div class="attendance">
      <!--头部-->
      <div class="attendance-title">
        <!-- 慧航升本 • 燃爆学堂 -->
        {{ pageTitle }}
      </div>
      <img
        @click="changeOld"
        class="change-img"
        src="https://appfile2.sbgw.cn/hhxtj/d27a037e14b44590ba39d89020bbb2ea.png"
        alt=""
      />
      <!--左侧统计表-->
      <div class="left-statis">
        <!-- 标题 -->
        <div class="left_title flex_test align_center">
          <div class="outer-circle">
            <div class="inner-circle"></div>
          </div>
          <p class="date">{{ currentTime }}</p>
          <div class="day">
            <p>{{ currentWeekDay }}</p>
            <p>{{ currentDate }}</p>
          </div>
          <div class="day_bar"></div>
          <div class="flex_test align_center">
            <img class="weather_img" :src="getImageSrc(weatherType)" />
            <div class="weather_text">{{ temperature }}</div>
          </div>
        </div>
        <div class="table-up" style="height: 56%" >
          <p class="table-tt1">个人学习积分（金币）排行榜</p>
          <div class="table-box integralGroup-table-box" v-if="gradeIntegraMemberDataDtos&&gradeIntegraMemberDataDtos.integralMembers && gradeIntegraMemberDataDtos.integralMembers.length>0">
            <div class="table-thead">
              <dl>
                <dt style="color: #98d7ff">排名</dt>
                <dt style="color: #98d7ff">姓名</dt>
                <dt style="color: #98d7ff">所在小组</dt>
                <dt style="color: #98d7ff">总金币</dt>
              </dl>
            </div>
            <div class="table-tbody">
              <div>
                <dl
                  v-for="item in gradeIntegraMemberDataDtos.integralMembers"
                  :key="item.index"
                  :class="getRowClass(item.order - 1)"
                  class="flex_test align_center"
                >
                  <dd class="flex_test align_center content_center">
                    <div v-if="item.order === 1" class="ranking_no_one">
                      {{ item.order }}
                    </div>
                    <div v-else class="ranking_no_two">
                      {{ item.order || "暂无排名" }}
                    </div>
                  </dd>
                  <dd :class="item.order == 1 ? 'special_color' : ''">
                    {{ item.studentName || "未填写" }}
                  </dd>
                  <dd :class="item.order == 1 ? 'special_color' : ''">
                    {{ item.integralTeamName }}
                  </dd>
                  <dd :class="item.order == 1 ? 'special_color' : ''">
                    {{ item.totalScore }}枚
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div class=" table-box integralGroup-table-box gray fs-18" v-else>
            暂无数据
          </div>
        </div>
        <div
          class="table-down mt-10"
          style="height: 35%"
         
        >
          <p class="table-tt2">小组学习积分（金币）榜排行榜</p>
          <div class="table-box integralGroup-table-box" v-if="
           gradeGroupIntegralDtos&&
            gradeGroupIntegralDtos.integrals &&
            gradeGroupIntegralDtos.integrals.length > 0
          ">
            <div class="table-thead">
              <dl>
                <dt style="color: #98d7ff">排名</dt>
                <dt style="color: #98d7ff">总金币</dt>
                <dt style="color: #98d7ff">组长</dt>
                <dt style="color: #98d7ff">组名</dt>
              </dl>
            </div>
            <div class="table-tbody"  >
              <div>
                <dl
                  v-for="item in gradeGroupIntegralDtos.integrals"
                  :key="item.index"
                  :class="getRowClass(item.order - 1)"
                  class="flex_test align_center"
                >
                  <dd class="flex_test align_center content_center">
                    <div v-if="item.order === 1" class="ranking_no_one">
                      {{ item.order }}
                    </div>
                    <div v-else class="ranking_no_two">
                      {{ item.order || "暂无排名" }}
                    </div>
                  </dd>
                  <dd :class="item.order == 1 ? 'special_color' : ''">
                    {{ item.totalScore }}枚
                  </dd>
                  <dd :class="item.order == 1 ? 'special_color' : ''">
                    {{ item.groupLeader || "未设置" }}
                  </dd>
                  <dd :class="item.order == 1 ? 'special_color' : ''">
                    {{ item.integralTeamName }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div class="table-box integralGroup-table-box gray fs-18" v-else>
            暂无数据
          </div>
        </div>
      </div>
      <!--雷达统计-->
      <div class="echart-box">
        <div class="date_box">
          <span class="date-item">
            日期
            <el-date-picker
              class="date-text test-item"
              v-model="timeOb"
              clear-icon="el-icon-date"
              type="date"
              placeholder="选择日期"
              @change="changeDateGo"
            >
            </el-date-picker>
            <i class="el-icon-caret-bottom el_icon_down el_icon_sele_down"></i>
          </span>
          <span class="class-select mr-30">
            班级
            <el-select
              @change="changeTodayClass"
              v-model="valueClass"
              placeholder="请选择"
              filterable
              :filter-method="customFilterMethod"
            >
              <div
                v-for="(group, index) in filteredGroupedTodayClassList"
                :key="index"
              >
                <div class="custom-option-group">
                      <el-option
                        v-for="item in group"
                        :key="item.gradeId"
                        :label="item.gradeName"
                        :value="item.gradeId"
                        class="custom-option-item"
                      />
                </div>
              </div>
            </el-select>
            <i class="el-icon-caret-bottom el_icon_down el_icon_sele_down"></i>
          </span>
          <span class="class-select class-select1">
            时间
            <el-select v-model="valueTime" placeholder="请选择" @change="changeTimeSchedule">
              <el-option
                v-for="(item, index) in optionsTime"
                :key="item.dailyScheduleId"
                :label="item.openTime"
                :value="item.dailyScheduleId"
              >
              </el-option>
            </el-select>
            <i class="el-icon-caret-bottom el_icon_down el_icon_sele_down"></i>
          </span>
        </div>
        <!-- 实到应到 -->
        <div class="people-signin">
          <ul class="flex_test align-center">
            <li class="flex_test align-center space-between-test signin_box mr-60 ml-16">
              <div class="actual_arrival"><i class="dot-green"></i>实到人数</div>
              <div class="font-green">{{ studentSign }}人</div>
            </li>
            <li class="flex_test align-center space-between-test signin_box">
              <div class="should_arrive"><i class="dot-white"></i>应到人数</div>
              <div>{{ studentCount }}人</div>
            </li>
          </ul>
        </div>
        <!--雷达图-->
        <div class="echart-inner student-zoom">
          <img
            src="https://appfile2.sbgw.cn/hhxtj/4b8bafb206114ca6ba5bfe3b17bed035.png"
            class="echart-inner-bg"
          />
          <!--中间倒计时-->
          <span :class="indexShow === 0 ? 'center-dot mt_ml_25' : 'center-dot'">
            <div :class="indexShow === 0 ? '' : 'text-wrapper_3 flex-col'">
              <span v-if="indexShow === 0" class="countdown">
                <img src="../assets/images/ellipsis.gif" class="ingGif" /><br />
                签到中<br />
                <b class="countdown-time">{{ clockTime }}</b>
              </span>
              <span v-else-if="indexShow === 1" class="text_57">未开始</span>
              <span v-else-if="indexShow === 2" class="text_57">上课中</span>
              <span v-else-if="indexShow === 3" class="text_57">已下课</span>
            </div>
          </span>
          <div v-if="studentListNew.length > 0">
            <span
              v-for="(item, index) in studentListNew"
              :key="index"
              :class="['student-item', `student-item-${index}`]"
              :style="initialStyles[index]"
              ><img
                :src="
                getStudentLogo(item.studentLog)
                  "
              /><b>{{ item.studentName || "未填写" }}</b></span
            >
          </div>
        </div>
        <img
          src="https://appfile2.sbgw.cn/hhxtj/6582569c137943d5b4653f5d30b0c2a9.png"
          class="echart-inner-bg-bottom"
        />
      </div>
      <!--右侧统计表-->
      <div class="right-statis">
        <div :class="examination.examinationId ? 'table-up' : 'table-up height-50'">
          <!--今日寄语-->
          <div v-if="siginSo" class="flex_test flex-wrap">
            <div
              class="msg_box flex_test align-center flex-wrap"
              style="margin-top: -10px; margin-bottom: 6px"
            >
              <img
                class="word-img"
                src="https://appfile2.sbgw.cn/hhxtj/71678b53cc6e4178ba229d96ae1ff191.png"
                alt=""
              />
              <div class="word-tt">今日寄语：</div>
              <div class="word-list" id="tgCars">
                <ul ref="box">
                  <li>{{ siginSo }}</li>
                </ul>
              </div>
            </div>
          </div>
          <p :class="examination.examinationId?'table-tt3':'table-tt3 height-tt-3'">班级早到榜前10名</p>
          <div class="table-box" :style="{ height: isShowClass ? '86%' : '160%' }"> 
            <div class="table-thead">
              <dl>
                <dt></dt>
                <dt style="color: #98d7ff">姓名</dt>
                <dt style="color: #98d7ff">班级排名</dt>
                <dt style="color: #98d7ff">全校排名</dt>
              </dl>
            </div>
            <div class="table-tbody">
              <div>
                <dl
                  v-for="item in earlyArrival"
                  :key="item.classOrder"
                  :class="[item.classOrder % 2 == 0 ? 'arrival_box1' : 'arrival_box']"
                >
                  <dd>
                    <div
                      v-if="item.classOrder % 2 != 0 && item.classOrder == 1"
                      class="orange1"
                    >
                      <div class="orange-line"></div>
                    </div>
                    <div v-else class="blue1">
                      <div class="blue-line"></div>
                    </div>
                  </dd>
                  <dd :class="item.classOrder == 1 ? 'special_color' : ''">
                    {{ item.studentName }}
                  </dd>
                  <dd>
                    <i class="special_color" v-if="item.classOrder == 1">NO.1</i>
                    <i v-if="item.classOrder != 1">NO.{{ item.classOrder }}</i>
                  </dd>
                  <dd :class="item.classOrder == 1 ? 'special_color' : ''">
                    {{ item.schoolOrder }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="divide3 table-down mt-20" v-if="examination.examinationId" :style="{ marginTop: isShowClass ? '11%' : '75%' }">
          <p class="table-tt4">班级阶段测评得分 <i :class="isShowClass?'el-icon-arrow-down':'el-icon-arrow-up'" style="font-size: 12px;cursor: pointer;" @click="isShowClass=!isShowClass">{{isShowClass?"收起":"展开"}}</i></p>
          <div class="table-box1" >
            <div class="table-thead1">
              <div class="flex_test space-between-test align-center">
                <div class="flex_test align-center">
                  <div class="bor-blue"></div>
                  应考人数：<span class="blue_font">{{ examination.studentCount }}</span
                  >人
                </div>
                <div class="flex_test align-center">
                  <div class="bor-blue"></div>
                  最高分：<span class="blue_font">{{ examination.maxScore }}</span
                  >分
                </div>
              </div>
              <div class="flex_test space-between-test align-center">
                <div class="flex_test align-center">
                  <div class="bor-ora"></div>
                  参考人数：<span class="orange_font">{{ examination.addCount }}</span
                  >人
                </div>
                <div class="flex_test align-center">
                  <div class="bor-ora"></div>
                  平均分：<span class="orange_font">{{ examination.averageScore.toFixed(2) }}</span
                  >分
                </div>
              </div>
            </div>
            <div id="mainchart" ref="barChart" v-show="isShowClass"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// jQuery
import $ from "jquery";
import {
  ClassAttendanceRadarChart,
  DailySchedulelist,
  GetGradeExamData,
} from "network/radar";
import { GetStudentListByIds } from "network/students";
import { timeFormatNew } from "common/utils";
import { requireCenterLoginForLargeScreen } from "@/common/largeScreenAuth";
import * as echarts from "echarts";

export default {
  name: "ExplosiveClassroom",
  data() {
    return {
      timeOb: new Date(),
      gradeId: "",
      valueClass: null,
      valueTime: "课时时段",
      optionsTime: [],
      todayClassList: [],
      attendanceRanking: [], //上课班级出勤排名
      earlyArrival: [], //班级早到榜前10名
      gradeGroupIntegralDtos: [], //班级
      gradeIntegraMemberDataDtos: [], //个人
      studentSignInRecordList: [], //学生签到
      studentId: [], //该班级所有学生ID
      studentList: [],
      studentListNew: [],
      startTime: "", //当前课时的开始时间
      finishTime: "", //当前结束的开始时间
      siginSo: "", //寄语
      studentSign: "", //实到人数
      studentCount: "", //应到人数
      areaBgW: "",
      areaBgH: "",
      flagIndex: null, //0未开始，1签到中，2上课中，3已下课
      indexShow: null,
      timer: null,
      clockTime: null, //签到倒计时
      timer2: null, //签到倒计时
      timer3: null, //学生倒计时
      offset: 0, // 初始偏移量为0
      currentTime: "",
      currentWeekDay: "",
      currentDate: "",
      pageTitle: "",
      weatherType: "",
      temperature: "",
      timeSet: "",
      examination: {},
      initialStyles: [
        { left: "69.8%", bottom: "65%" },
        { left: "74%", bottom: "58%" },
        { left: "73%", bottom: "47%" },
        { left: "68%", bottom: "43%" },
        { left: "61%", bottom: "41.2%" },
        { left: "53%", bottom: "41.5%" },
        { left: "45%", bottom: "44%" },
        { left: "38%", bottom: "47%" },
        { left: "32%", bottom: "51%" },
        { left: "27%", bottom: "55%" },
        { left: "23%", bottom: "62%" },
        { left: "21%", bottom: "72%" },
        { left: "26%", bottom: "78%" },
      ],
      imageCache: {}, // 用于缓存图片资源
      isShowClass:true, //是否显示班级测评得分
      searchKeyword: '',
      isSelecting:false,
      // 新增：当前选中的课时信息
      currentSchedule: null,
      // 新增：所有班级的课时数据
      allClassSchedules: {},
      currentScheduleId: null // 新增：当前选中的课时ID
    };
  },
  computed: {
    scoresData() {
      return [
        this.examination.score1,
        this.examination.score2,
        this.examination.score3,
        this.examination.score4,
      ];
    },
    yAxisMax() {
      const scores = this.scoresData;
      const maxScore = Math.max(...scores);

      if (maxScore === 0) {
        return 0; // 当所有分数都为 0 时返回 0
      }

      return Math.ceil(maxScore / 10) * 10; // 否则向上取整到最接近的整十数
    },
    groupedTodayClassList() {
      const chunkedArray = [];
      for (let i = 0; i < this.todayClassList?.length; i += 2) {
        chunkedArray.push(this.todayClassList?.slice(i, i + 2));
      }
      return chunkedArray;
    },
    filteredGroupedTodayClassList() {
      if (this.searchKeyword == '') {
        return this.groupedTodayClassList;
      }
      const filteredList = this.todayClassList.filter(item =>
        item.gradeName.toLowerCase().includes(this.searchKeyword.toLowerCase())
      );
      const chunkedArray = [];
      for (let i = 0; i < filteredList.length; i += 2) {
        chunkedArray.push(filteredList.slice(i, i + 2));
      }
      return chunkedArray;
    }
  },
  created() {
    this.updateTime();
    let that = this;
    // 排行榜滚动
    var time = setInterval(function () {
      that.Scroll();
    }, 5000);
  },
  destroyed() {
    clearInterval(this.countDown);
  },
  mounted() {
    if (requireCenterLoginForLargeScreen(this, this.$route)) {
      return;
    }
    this.intervalId  = setInterval(this.startTimer, 600000);// 每10分钟（600000毫秒）执行一次
    // 格式化三个接口的执行顺序
    this.getSelect1(false,1);
    window.onload = function () {};
    this.timer2 = setInterval(this.scroll, 3000);
    // this.timer3 = setInterval(this.scrollStudent, 2000);
  },
  beforeDestroy() {
    if (this.timeSet) {
      clearInterval(this.timeSet); // 组件销毁前清除定时器
    }
    if (this.timer) {
      clearInterval(this.timer); // 组件销毁前清除定时器
    }
    if (this.timer2) {
      clearInterval(this.timer2); // 组件销毁前清除定时器
    }
    if (this.timer3) {
      clearInterval(this.timer3); // 组件销毁前清除定时器
    }
  },
  activated() {},
  methods: {
    getStudentLogo(studentLog) {
      if (studentLog && this.imageCache[studentLog]) {
        return this.imageCache[studentLog];
      }
      const defaultLogo = 'https://appfile2.sbgw.cn/hhxt/15c28ca7-4be9-4809-be93-cdea1a02112e.jpg';
      this.imageCache[studentLog || defaultLogo] = studentLog || defaultLogo;
      return studentLog || defaultLogo;
    },
    startCarousel() {
      let currentIndex = 0;
      this.timer3 = setInterval(() => {
        const nextIndex = (currentIndex + 1) % this.studentList.length;
        const nextList = this.studentList.slice(nextIndex, nextIndex + 13);

        if (nextList.length < 13) {
          nextList.push(...this.studentList.slice(0, 13 - nextList.length));
        }
        // 只更新必要的数据
        const updatedList = nextList.map((item, index) => {
          const existingItem = this.studentListNew[index];
          if (existingItem && existingItem.studentLog === item.studentLog && existingItem.studentName === item.studentName) {
            return existingItem;
          }
          return item;
        });
        this.studentListNew = updatedList;
        currentIndex = nextIndex;
      }, 2000); // 每2秒更新一次
    },
    getImageSrc(weatherType) {
      if (weatherType?.includes("云"))
        return "https://appfile2.sbgw.cn/hhxtj/2fff8c51447d470495e123ee64c421e5.png";
      if (weatherType?.includes("雨"))
        return "https://appfile2.sbgw.cn/hhxtj/dafe68ee897240d0a24d2ffcb41f485f.png";
      if (weatherType?.includes("雪"))
        return "https://appfile2.sbgw.cn/hhxtj/fcced926fa5543339ca2e30324ec48cc.png";
      if (weatherType?.includes("晴") || weatherType?.includes("阳"))
        return "https://appfile2.sbgw.cn/hhxtj/0d770c0355dc4fb8bc36fa3f6d40e4ec.png";
      return "https://appfile2.sbgw.cn/hhxtj/2fff8c51447d470495e123ee64c421e5.png"; // 返回默认图片路径
    },
    startTimer() {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      // 检查是否在目标时间段内
      if ((currentHour === 7 && currentMinute >= 30) || 
          (currentHour === 10 && currentMinute <= 30) ||
          (currentHour === 12 && currentMinute >= 30) || 
          (currentHour === 15 && currentMinute <= 30)) {
            this.getSelect1(true);
      }
    },
    async getExamData() {
      if(!this.valueClass) return false
      // console.log(this.yAxisMax,'this.yAxisMax')
      const res = await GetGradeExamData({
        gradeId: this.valueClass,
      });
      if (res.data.code == 1) {
        this.isShowClass = true
        this.examination = res.data.result;
        this.$nextTick(() => {
          this.canvasInit();
        });
      }else{
        this.examination = {}
        this.isShowClass = false
      }
    },
    canvasInit() {
      let colorlist = [
        new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "#98D7FF" },
          { offset: 1, color: "rgba(152,215,255,0.3)" },
        ]),
        new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "#98D7FF" },
          { offset: 1, color: "rgba(152,215,255,0.3)" },
        ]),
        new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "#FFA169" },
          { offset: 1, color: "rgba(255,161,105,0.3)" },
        ]),
        new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "#98D7FF" },
          { offset: 1, color: "rgba(152,215,255,0.3)" },
        ]),
      ];
      const option = {
        // 表格边距
        grid: {
          left: "0%",
          right: "10%",
          containLabel: true,
        },
        xAxis: {
          name: "",
          nameTextStyle: {
            fontWeight: "bold",
            verticalAlign: "top",
            lineHeight: 20,
          },
          data: ["0-49", "50-69", "70-89", "90-100"],
          axisLine: {
            lineStyle: {
              color: "#85878a",
            },
          },
          axisTick: {
            //是否显示网状线
            show: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: this.yAxisMax,
          interval: 200,
          offset: 0,
          name: "人",
          nameTextStyle: {
            align: "right",
            fontWeight: "bold",
          },
          nameGap: 20,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#171c24",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#85878a",
            },
          },
          axisLabel: {
            // 确保每个数值都显示
            formatter: function (value) {
              return value;
            },
            rotate: 0, // 保持垂直
          },
        },
        series: [
          {
            type: "bar",
            data: [
              this.examination.score1,
              this.examination.score2,
              this.examination.score3,
              this.examination.score4,
            ],
            barWidth: 30,
            showBackground: true,
            backgroundStyle: {
              color: "#1e232b",
            },
            itemStyle: {
              color: "#1e232b",
            },
            z: 1,
          },
          {
            data: [
              this.examination.score1,
              this.examination.score2,
              this.examination.score3,
              this.examination.score4,
            ],
            type: "bar",
            barWidth: 15,
            itemStyle: {
              color: function (params) {
                return colorlist[params.dataIndex];
              },
            },
            barGap: "-75%", //这句话就是为了让柱形图的柱子到达背景图上
          },
        ],
      };
      const E = echarts.init(this.$refs.barChart);
      E.setOption(option);
    },
    updateTime() {
      // 获取当前时间
      const now = new Date();
      // 格式化时间为字符串
      const formattedTime = now.toLocaleTimeString();
      this.currentTime = formattedTime;
      // 每秒更新一次时间
      setTimeout(() => this.updateTime(), 1000);
      // 获取当前日期
      const nowDay = new Date();
      // 获取星期几
      const weekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      const dayOfWeek = weekDays[nowDay.getDay()];
      this.currentWeekDay = dayOfWeek;

      // 格式化日期
      const year = nowDay.getFullYear();
      const month = String(nowDay.getMonth() + 1).padStart(2, "0");
      const day = String(nowDay.getDate()).padStart(2, "0");
      this.currentDate = `${year}/${month}/${day}`;
    },
    scroll() {
      setTimeout(() => {
        if(this.examination.examinationId){
          if (!this.isShowClass) {
            //按照classOrder排序
             this.earlyArrival = this.earlyArrival?.sort((a, b) => {
              return a.classOrder - b.classOrder;
            });
           // 如果isShowClass为false，则班级早到榜不滚动
        }else{
          this.earlyArrival.push(this.earlyArrival[0]); // 将数组的第一个元素添加到数组的最后
          this.earlyArrival.shift(); //删除数组的第一个元素
        }
        }
        if (this.gradeGroupIntegralDtos?.length > 4) {
          this.gradeGroupIntegralDtos?.integrals.push(
            this.gradeGroupIntegralDtos?.integrals[0]
          ); // 将数组的第一个元素添加到数组的最后
          this.gradeGroupIntegralDtos.integrals?.shift(); //删除数组的第一个元素
        }
        this.gradeIntegraMemberDataDtos?.integralMembers?.push(
          this.gradeIntegraMemberDataDtos?.integralMembers[0]
        ); // 将数组的第一个元素添加到数组的最后
        this.gradeIntegraMemberDataDtos?.integralMembers?.shift(); //删除数组的第一个元素
      }, 1000);
    },
    // scrollStudent() {
    //   setTimeout(() => {
    //     // 获取当前的13个元素
    //     let studentList = JSON.parse(JSON.stringify(this.studentList));
    //     const listLength = studentList.length;
    //     const endIndex = this.offset + 13;
    //     this.studentListNew = studentList.slice(this.offset, endIndex);

    //     // 如果当前索引加上13超过了数组长度，需要补全
    //     if (endIndex > listLength) {
    //       const remaining = 13 - (listLength - this.offset);
    //       this.studentListNew = this.studentListNew.concat(
    //         studentList.slice(0, remaining)
    //       );
    //     }

    //     // 更新起始索引
    //     this.offset = (this.offset + 1) % listLength;

    //     // 将第一个元素移到末尾
    //     if (this.studentListNew.length > 0) {
    //       const firstElement = this.studentListNew.shift();
    //       this.studentListNew.push(firstElement);
    //     }
    //   }, 1500);
    // },
    stopScrolling() {
      clearInterval(this.interval);
    },
    getRowClass(index) {
      // 三种颜色
      const colors = ["row1", "row2", "row3", "row4", "row5", "row6"];
      return colors[index % colors.length];
    },
    // 执行顺序1
    async getSelect1(flag, val, preservedClassId = null) {
      
      let _this = this;
      let timeGet = timeFormatNew(this.timeOb, "yyyy-MM-dd");
      
      // 从URL参数中获取班级ID和课时ID（优先使用URL参数）
      // 但是如果是日期切换操作（传入了preservedClassId），则优先使用传入的班级ID
      if (preservedClassId) {
        // 日期切换时，优先使用传入的要保持的班级ID
        this.valueClass = preservedClassId;
      } else if (this.$route.query.classId) {
        // 确保数据类型一致，转换为数字类型
        this.valueClass = parseInt(this.$route.query.classId);
      }
      
      if (this.$route.query.scheduleId) {
        this.currentScheduleId = this.$route.query.scheduleId;
      }
      
      if (this.$route.query.dt) {
        if(val == 1) {
          this.timeOb = this.$route.query.dt;
          await this.getDailySchedulelist(this.$route.query.dt, flag, preservedClassId);
        }else{
          await this.getDailySchedulelist(timeGet, flag, preservedClassId);
        }
        // 获取今天开课班级
      } else {
        await this.getDailySchedulelist(timeGet, flag, preservedClassId);
      }
      this.timeDiffTime = setInterval(function () {
        _this.clockCountdown();
      }, 1000);
      this.getSelect2();
      this.$nextTick(() => {
        this.lunbo();
      });
    },
    // 执行顺序2
    async getSelect2() {
      await this.getClassAttendanceRadarChart();
      this.getSelect3();
      this.getExamData();
      this.$nextTick(()=>{
        this.searchKeyword = ''
      })
    },
    // 执行顺序3
    async getSelect3() {
      await this.getStudeyDeisl();
    },
    //   选择时间
    changeDateGo(time) {
      // 保存点击日期之前选中的班级ID，用于在新日期中保持选中状态
      const previousSelectedClassId = this.valueClass;
      
      this.timeOb = timeFormatNew(time, "yyyy-MM-dd");
      
      clearInterval(this.timer);
      // 直接调用数据加载方法，不使用页面跳转，传递之前选中的班级ID
      this.getSelect1(false, 0, previousSelectedClassId);
    },
    // 新增：选择课时
    changeTimeSchedule(scheduleId) {
      // 根据选中的课时ID更新相关信息
      const selectedSchedule = this.optionsTime.find(item => item.dailyScheduleId === scheduleId);
      if (selectedSchedule) {
        this.siginSo = selectedSchedule.todayMessage;
        this.startTime = selectedSchedule.startTime;
        this.finishTime = selectedSchedule.finishTime;
        this.currentScheduleId = scheduleId;
        // 重新获取该课时的数据
        this.getSelect2();
      }
    },
    
    // 选择班级
    changeTodayClass(val) {
      this.optionsTime = [];
      this.currentScheduleId = null;
      let found = false;
      this.todayClassList.forEach((org) => {
        if (parseInt(org.gradeId) === parseInt(val)) {
          if (org.dailyScheduleChildStatisticDtos && org.dailyScheduleChildStatisticDtos.length > 0) {
            this.optionsTime = org.dailyScheduleChildStatisticDtos.map(schedule => ({
              dailyScheduleId: schedule.dailyScheduleId,
              openTime: schedule.openTime,
              todayMessage: schedule.todayMessage,
              startTime: schedule.startTime,
              finishTime: schedule.finishTime
            }));
            if (this.optionsTime.length > 0) {
              this.valueTime = this.optionsTime[0].dailyScheduleId;
              this.currentScheduleId = this.optionsTime[0].dailyScheduleId;
              this.siginSo = this.optionsTime[0].todayMessage;
              this.startTime = this.optionsTime[0].startTime;
              this.finishTime = this.optionsTime[0].finishTime;
              found = true;
            }
          } else {
            this.valueTime = org.dailyScheduleId || org.gradeId;
            this.currentScheduleId = org.dailyScheduleId || org.gradeId;
            this.siginSo = org.todayMessage;
            this.startTime = org.startTime;
            this.finishTime = org.finishTime;
            this.optionsTime.push({
              dailyScheduleId: org.dailyScheduleId || org.gradeId,
              openTime: org.openTime,
              todayMessage: org.todayMessage,
              startTime: org.startTime,
              finishTime: org.finishTime
            });
            found = true;
          }
        }
      });
      this.valueClass = parseInt(val);
      if (found && this.currentScheduleId) {
        this.getSelect2();
      }
    },
    customFilterMethod(keyword) {
      this.searchKeyword = keyword;
    },
    // 剩余时间格式化
    countdown(times) {
      if (times > 0) {
        let hours = this.addZero(Math.floor((times / 1000 / 60 / 60) % 24));
        let minutes = this.addZero(Math.floor((times / 1000 / 60) % 60));
        let seconds = this.addZero(Math.floor((times / 1000) % 60)); //秒
        this.clockTime = `${hours}:${minutes}:${seconds}`;
      } else {
        // return "加载中";
      }
    },
    // 个位补零
    addZero(d) {
      return parseInt(d) < 10 ? "0" + d : d;
    },
    // 获取指定时间的今日开课班级列表
    async getDailySchedulelist(timeGet, flag, preservedClassId = null) {
      const { data: result } = await DailySchedulelist(timeGet);
      if (result.code === 1) {
        if (result.result && result.result.length > 0) {
          this.todayClassList = result.result;
          
          // 保存当前选中的班级ID和课时ID
          const currentSelectedClassId = this.valueClass;
          const currentSelectedScheduleId = this.currentScheduleId;
          
          // 确定要查找的班级ID：优先使用传入的preservedClassId（日期切换时要保持的班级）
          const targetClassId = preservedClassId;
          
          // 优先保持已选中的班级
          let selectedClass = null;
          if (targetClassId) {
            // 确保数据类型一致，都转换为数字进行比较
            const targetGradeId = parseInt(targetClassId);
            selectedClass = this.todayClassList.find(c => parseInt(c.gradeId) === targetGradeId) || null;
          }
          
          // 如果选中的班级在新日期中不存在，则选择第一个班级
          if (!selectedClass) {
            if (this.todayClassList.length > 0) {
              selectedClass = this.todayClassList[0];
              this.valueClass = parseInt(selectedClass.gradeId);
            } else {
              // 如果没有班级数据，清空选择
              this.optionsTime = [];
              this.valueTime = '';
              this.currentScheduleId = null;
              this.siginSo = '';
              this.startTime = '';
              this.finishTime = '';
              this.$message && this.$message.info && this.$message.info('该日期没有班级数据');
              return;
            }
          } else {
            // 保持当前选中的班级
            this.valueClass = parseInt(selectedClass.gradeId);
          }

          // 构建选中班级的课时列表
          if (selectedClass.dailyScheduleChildStatisticDtos && selectedClass.dailyScheduleChildStatisticDtos.length > 0) {
            this.optionsTime = selectedClass.dailyScheduleChildStatisticDtos.map(schedule => ({
              dailyScheduleId: schedule.dailyScheduleId,
              openTime: schedule.openTime,
              todayMessage: schedule.todayMessage,
              startTime: schedule.startTime,
              finishTime: schedule.finishTime
            }));
          } else {
            // 兼容单个课时的情况
            this.optionsTime = [{
              dailyScheduleId: selectedClass.dailyScheduleId || selectedClass.gradeId,
              openTime: selectedClass.openTime,
              todayMessage: selectedClass.todayMessage,
              startTime: selectedClass.startTime,
              finishTime: selectedClass.finishTime
            }];
          }

          // 优先保持已选中的课时，如果不存在则选第一个
          const existsSchedule = this.optionsTime.find(t => t.dailyScheduleId === currentSelectedScheduleId);
          const finalSchedule = existsSchedule || this.optionsTime[0];
          this.valueTime = finalSchedule.dailyScheduleId;
          this.currentScheduleId = finalSchedule.dailyScheduleId;
          this.siginSo = finalSchedule.todayMessage;
          this.startTime = finalSchedule.startTime;
          this.finishTime = finalSchedule.finishTime;
        } else {
          this.todayClassList = [];
          this.optionsTime = [];
          this.valueClass = "";
          this.valueTime = "";
          this.siginSo = "";
          this.currentScheduleId = null;
          this.$alert("没有上课班级请选择其他上课时间的班级", '提示');
        }
      } else {
        // this.$alert(result.message);
      }
    },
    
    // 新增：处理班级课时数据的方法
    processClassSchedules() {
      this.allClassSchedules = {};
      
      this.todayClassList.forEach(classItem => {
        const gradeId = classItem.gradeId;
        
        if (classItem.dailyScheduleChildStatisticDtos && classItem.dailyScheduleChildStatisticDtos.length > 0) {
          // 新数据结构：有多个课时
          this.allClassSchedules[gradeId] = {
            gradeInfo: {
              gradeId: classItem.gradeId,
              gradeName: classItem.gradeName,
              todayMessage: classItem.todayMessage
            },
            schedules: classItem.dailyScheduleChildStatisticDtos
          };
        } else {
          // 兼容旧数据结构：单个课时
          this.allClassSchedules[gradeId] = {
            gradeInfo: {
              gradeId: classItem.gradeId,
              gradeName: classItem.gradeName,
              todayMessage: classItem.todayMessage
            },
            schedules: [{
              dailyScheduleId: classItem.dailyScheduleId || classItem.gradeId,
              openTime: classItem.openTime,
              startTime: classItem.startTime,
              finishTime: classItem.finishTime,
              todayMessage: classItem.todayMessage
            }]
          };
        }
      });
    },
    // 获取数据
    async getClassAttendanceRadarChart() {
      // 当上一个接口返回数据未空时，中断进度
      if (this.todayClassList.length == 0) {
        this.attendanceRanking = [];
        this.earlyArrival = [];
        this.gradeGroupIntegralDtos = [];
        this.gradeIntegraMemberDataDtos = [];
        this.studentSignInRecordList = [];
        return false;
      };
      let timeObj = timeFormatNew(this.timeOb, "yyyy-MM-dd");
      const { data: result } = await ClassAttendanceRadarChart({
        dt: this.startTime,
        gradeId: this.valueClass,
        dailyScheduleId: this.currentScheduleId, // 确保每次都带课时id
      }, false);
      if (result.code === 1) {
        if (result.result) {
          this.pageTitle = result.result.title;
          this.weatherType = result.result.weatherType;
          this.temperature = result.result.temperature;
          this.studentCount = result.result.studentCount;
          this.studentSign = result.result.studentSign;
          this.attendanceRanking = result.result.attendanceRanking;
          this.earlyArrival = result.result.earlyArrival;
          this.gradeGroupIntegralDtos = result.result.gradeGroupIntegralDtos;
          this.gradeIntegraMemberDataDtos = result.result.gradeIntegraMemberDataDtos;
          this.studentSignInRecordList = result.result.studentSignInRecordList;
          if (this.studentSignInRecordList) {
            this.studentId = this.studentSignInRecordList.map((org) => {
              return org.studentId;
            });
          }
        } else {
          this.$alert("该班级没有上课的课时，请选择其他班级");
        }
      } else {
        this.$alert(result.message);
      }
    },
    // 获取学生公共集合
    async getStudeyDeisl() {
      // 当上一个接口返回数据未空时，中断进度
      if (this.studentId.length > 0) {
        let studentSignIn = [];
        studentSignIn = this.studentSignInRecordList.map((org) => {
          return org;
        });
        const result = await GetStudentListByIds(this.studentId);
        if (result.data.code === 1) {
          this.studentList = result.data.result;
          studentSignIn.map((org) => {
            result.data.result.map((o) => {
              if (org.studentId === o.id) {
                org.studentLog = o.avatars;
              }
            });
          });
          this.studentList = studentSignIn;
          let student = JSON.parse(JSON.stringify(studentSignIn));
          this.studentListNew = student?.slice(0, 13);
          this.startCarousel();
        }
      } else {
        this.studentList = [];
      }
    },
    // 排行榜滚动
    Scroll() {
      $(".tgRoll").each(function () {
        var area = $(this);
        //单行高度
        var he = area.find("dl").height();
        //单次滚动行数
        // var lines = parseInt(area.height()/he);
        var lines = 4;
        if (area.height() >= area.find("dl").length * he) {
          return;
        } else {
          area.find("div").animate(
            {
              marginTop: "-" + he * lines,
            },
            200,
            function () {
              for (let i = 1; i <= lines; i++) {
                area.find("dl:first").appendTo(area.find("div"));
              }
              area.find("div").css({
                marginTop: 0,
              });
            }
          );
        }
      });
    },
    // 寄语轮播
    lunbo() {
      if (this.siginSo) {
        // this.$refs.box.style.left = "20px";
        let box = this.$refs.box;
        let boxWidth = box.offsetWidth;
        var left = null;
        if (this.timer) {
          clearInterval(this.timer); // 组件销毁前清除定时器
        }
        this.timer = setInterval(function () {
          left -= 3;
          if (left < -boxWidth / 2) {
            left = 200;
          }
          box.style.left = left + "px";
        }, 50);
      } else {
        // clearInterval(timer)
      }
    },
    // 计算打卡倒计时
    clockCountdown() {
      var date = new Date();
      var now = date.getTime();
      //   //     //设置截止时间
      var str = new Date(this.startTime).getTime();
      var end = new Date(this.finishTime).getTime();
      //   课时开始前十分钟
      var tenTime = 10 * 60 * 1000;
      //   //      //时间差
      let diffTime = str - now;
      if (now < str) {
        if (diffTime < tenTime && diffTime > 0) {
          this.indexShow = 0;
          this.countdown(diffTime);
        } else {
          this.indexShow = 1;
        }
      } else if (now > str && now < end) {
        this.indexShow = 2;
      } else if (now > end) {
        this.indexShow = 3;
      }
    },
    changeOld() {
      const url = "/RadarClassAttendance";
      window.open(url, "_blank");
      this.todayMessagesList = [];
      this.executionOrder();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timeDiffTime);
  },
};
</script>

<style scoped src="../assets/css/ashore.css"></style>
<style lang="scss" scoped>
/*第一层*/
@keyframes one {
  0% {
    left: 0px;
  }

  100% {
    left: 500px;
  }
}

@keyframes animY {
  0% {
    top: 0px;
  }

  100% {
    top: 300px;
  }
}

@keyframes scale {
  0% {
    transform: scale(0.4);
    z-index: 0;
  }

  50% {
    transform: scale(1);
    z-index: 3;
  }

  100% {
    transform: scale(0.5);
    z-index: 0;
  }
}

.ball {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  position: absolute;
  color: rgb(255, 255, 255);
  font-size: 26px;
  display: flex;
  /* align-items: center; */
  line-height: 50px;
  justify-content: center;
  background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
  z-index: 3;
  /*动画执行一次所需时间*/
  animation-duration: 10s, 10s, 20s;
  /*动画以何种运行轨迹完成一个周期*/
  animation-timing-function: cubic-bezier(0.36, 0, 0.64, 1);
  /*动画播放次数,无线循环播放*/
  animation-iteration-count: infinite;
  /*是否轮流反向播放动画 alternate:正向播放*/
  animation-direction: alternate;
  animation-name: one, animY, scale;
}

.ball p {
  padding-top: 28px;
  text-shadow: 0px 0px 3px rgb(12, 46, 62);
}

#lopp {
  width: 500px;
  height: 300px;
  border: 2px solid #999;
  border-radius: 50%;
  position: absolute;
  left: 70px;
  top: 80px;
}
</style>
<style scoped>
.table-thead dl dt,
.table-tbody dl dd {
  float: left;
  font-size: 14px;
  padding: 6px;
  line-height: 24px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 25%;
}
div {
  box-sizing: border-box;
}
.flex_test {
  display: flex;
}
.align_center {
  align-items: center;
}
.arrival_box {
  height: 46px;
  line-height: 46px;
  background: url("../assets/images/border_early.png") no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}
.arrival_box1 {
  height: 46px;
  line-height: 46px;
  background: url("https://appfile2.sbgw.cn/hhxtj/4bdfde31f8fd4152b7a56ba84cdcd771.png")
    no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}
.left_title {
  color: #fff;
  margin-bottom: 5px;
}
.weather_img {
  width: 33px;
  height: 33px;
}
.left-table,
.center-table {
  margin-right: 2%;
}

.left-statis,
.right-statis {
  position: absolute;
  top: 70px;
  right: auto;
  bottom: 15px;
}

.left-statis {
  left: 30px;
  top: 43px;
}

.right-statis {
  right: 30px;
}

.table-up {
  height: 42%;
}
.height-50 {
  height: 80%;
}
.table-down {
  height: 50%;
  margin-top: -7%;
  max-height: 480px;
}
.mt-20 {
  margin-top: 11%;
}
.mt-10 {
  margin-top: -2px;
}
.table-up,
.table-down {
  width: 423px;
  text-align: center;
}

.left-statis .table-tt,
.right-statis .table-tt {
  font-size: 14px;
}
.table-tt1 {
  height: 9.5%;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  color: #ffffff;
  text-align: left;
  padding-left: 50px;
  background: url("https://appfile2.sbgw.cn/hhxtj/9af4922b27274e8cbc7e3c88aa9e3f39.png")
    no-repeat;
  background-size: 100% 100%;
  margin-top: 3px;
  font-size: 18px;
  line-height: 45px;
}
.table-tt2 {
  height: 16%;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  color: #ffffff;
  text-align: left;
  padding-left: 50px;
  background: url("https://appfile2.sbgw.cn/hhxtj/9e1ab9dd41a84c10a7480e84856b79fe.png")
    no-repeat;
  background-size: 100% 100%;
  font-size: 18px;
  line-height: 45px;
}
.table-tt3 {
  height: 12.5%;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  color: #ffffff;
  text-align: left;
  padding-left: 50px;
  background: url("https://appfile2.sbgw.cn/hhxtj/f259d9b941724c898836a2ee66b207cc.png")
    no-repeat;
  background-size: 100% 100%;
  margin-top: 3px;
  font-size: 18px;
  line-height: 45px;
}
.height-tt-3{
  height: 7.5%;
}
.table-tt4 {
  height: 12%;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  color: #ffffff;
  text-align: left;
  padding-left: 50px;
  background: url("https://appfile2.sbgw.cn/hhxtj/11c2b47504ea47b49c256d7fbdc1905f.png")
    no-repeat;
  background-size: 100% 100%;
  margin-top: 3px;
  font-size: 18px;
  line-height: 45px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
}

.table-up .table-tt {
  height: 12%;
}

.table-up .table-box {
  height: 86%;
  font-size: 16px;
}

.table-down .table-tt {
  height: 8%;
}

.table-down .table-box {
  height: 90%;
}
.table-box1 {
  height: 80%;
  position: relative;
}
.table-thead1 {
  width: 290px;
  position: absolute;
  top: 0;
  left: 15%;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 14px;
  color: #d5e1f1;
}
.bor-blue {
  width: 6px;
  height: 6px;
  background: #00d5ff;
  border-radius: 50%;
  margin-right: 7px;
}
.bor-ora {
  width: 6px;
  height: 6px;
  background: #ffb24e;
  margin-right: 7px;
  border-radius: 50%;
}
.orange_font {
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 16px;
  color: #ffb24e;
  margin-right: 4px;
}
.blue_font {
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 16px;
  margin-right: 4px;
  color: #00d5ff;
}
.table-up .table-tbody {
  height: 89%;
}

.table-down .table-tbody {
  height: 93%;
}

.left-statis .table-thead dl dt,
.left-statis .table-tbody dl dd,
.right-statis .table-thead dl dt,
.right-statis .table-tbody dl dd {
  font-size: 16px;
  line-height: 38px;
  padding: 5px;
}
.left-statis .table-thead dl dt,
.right-statis .table-thead dl dt {
  font-size: 14px;
}
.table-up .table-thead dl dt,
.table-up .table-tbody dl dd,
.right-table .table-thead dl dt,
.right-table .table-tbody dl dd {
  width: 24%;
}

/* .table-up .table-thead dl dt:nth-child(2),
.table-up .table-tbody dl dd:nth-child(2),
.right-table .table-thead dl dt:nth-child(2),
.right-table .table-tbody dl dd:nth-child(2) {
  width: 49%;
}

.table-up .table-thead dl dt:first-child + dt,
.table-up .table-tbody dl dd:first-child + dd,
.right-table .table-thead dl dt:first-child + dt,
.right-table .table-tbody dl dd:first-child + dd {
  width: 49%;
} */

/*IE兼容写法*/

.echart-box {
  width: 100%;
  height: 100%;
  padding-left: 330px;
  padding-top: 50px;
  padding-right: 330px;
  box-sizing: border-box;
}

.echart-inner {
  width: 100%;
  height: 100%;
  /*min-width:694px;min-height: 740px;background: url(../image/echart_bg.png) no-repeat center center;background-size:100% auto;*/
  position: relative;
  margin: auto;
}

.echart-inner-bg {
  width: 155%;
  height: 125%;
  /*min-width:694px;*/
  position: absolute;
  transform: translate(-50%, -50%);
  /* transform: translateX(-50%); */
  top: 44%;
  left: 50%;
  /*margin-left:-347px;margin-top:-333px;*/
  z-index: -11;
}
.echart-inner-bg-bottom {
  width: auto;
  height: 160%;
  /*min-width:694px;*/
  position: absolute;
  transform: translate(-50%, -50%);
  /* transform: translateX(-50%); */
  top: 93%;
  left: 67%;
  /*margin-left:-347px;margin-top:-333px;*/
  z-index: -11;
}

.center-dot {
  width: 200px;
  line-height: 32px;
  height: 120px;
  display: inline-block;
  position: absolute;
  /*top:50%;left:50%;margin-top:-64px;margin-left:-100px ;*/
  color: #fdf405;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  padding-top: 6px;
  box-sizing: border-box;
  z-index: 111;
  transform: translate(-50%, -50%);
  top: 39%;
  left: 51%;
}
.mt_ml_25 {
  margin-top: -25px;
  margin-left: -25px;
}
.ingGif {
  width: 30%;
  height: auto;
  margin-top: -15px;
  margin-bottom: 15px;
}

.countdown-time {
  font-size: 18px;
}

.countdown-time em {
  font-style: normal;
}

::v-deep .default-text {
  width: 200px;
  height: 48px;
  line-height: 48px;
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -24px;
  margin-left: -100px;
  color: #fdf405;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
}

/* .student-zoom{width: 100%;height: 100%;position: relative;} */

::v-deep .student-item {
  display: inline-block;
  width: 48px;
  height: 62px;
  text-align: center;
  position: absolute;
  z-index: 111;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-direction: reverse;
  will-change: transform;
  transform: translate3d(0, 0, 0); /* 触发硬件加速 */
}

::v-deep .student-item img {
  width: 47px;
  height: 47px;
  border-radius: 50%;
  border: 2px solid #5dc0f8;
  box-shadow: 0 0px 10px #5dc0f8;
}

::v-deep .student-item b {
  display: block;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  margin-top: 4px;
}

.attendance-ritbot {
  width: 300px;
  position: fixed;
  top: 62px;
  right: 330px;
  text-align: left;
  line-height: 36px;
  z-index: 999;
}

.attendance-ritbot .word-list {
  width: 220px;
}
.signin_box {
  width: 170px;
  height: 68px;
}
.mr-60 {
  margin-right: 60px;
}
.ml-16 {
  margin-left: 16px;
}
.people-signin {
  width: 441px;
  height: 54px;
  line-height: 68px;
  margin: 0 auto;
  text-align: center;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  font-size: 14px;
  background: url("https://appfile2.sbgw.cn/hhxtj/97093550ba2e4a9aa0f3dc142e202da3.png")
    no-repeat;
  background-size: 420px;
  background-position: -5px 50px;
}
.actual_arrival,
.should_arrive {
  font-family: Adobe Heiti Std;
  font-weight: normal;
  font-size: 15px;
  color: #a0bde0;
}
.people-signin ul li {
  font-size: 16px;
  color: #fff;
  line-height: 28px;
}

.dot-white,
.dot-green {
  width: 5px;
  height: 5px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  margin-top: -2px;
  border-radius: 50%;
}

.dot-white {
  background-color: #3d94ff;
}

.dot-green {
  background-color: #1bef6b;
}

.integralGroup-table-box .table-thead dl dt,
.integralGroup-table-box .table-tbody dl dd,
.integral-box .table-thead dl dt,
.integral-box .table-tbody dl dd {
  width: 25% !important;
  line-height: 36px;
}

.pos-hint {
  font-size: 12px;
  color: #54ecff;
  position: absolute;
  left: 330px;
  bottom: 10px;
}

.divide3 .table-thead dl dt,
.divide3 .table-tbody dl dd {
  width: 33.33%;
}

.el_icon_sele_down {
  right: 8px;
}

.attendance-footer {
  width: 1440px;
  position: absolute;
  bottom: 15px;
  left: 50%;
  margin-left: -720px;
  text-align: left;
  padding: 0 30px;
  line-height: 36px;
}

.word-tt {
  width: 100px;
  white-space: nowrap;
  color: #fa9e68;
  font-size: 16px;
}

.word-list {
  font-size: 0;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  width: 1300px;
  height: 36px;
  line-height: 55px;
  overflow: hidden;
  margin-bottom: 20px;
}

.word-list ul {
  position: absolute;
  left: 0;
  top: 0;
}

.word-list ul li {
  float: left;
  color: #fff;
  font-size: 16px;
  margin-right: 15px;
}

.class-select >>> .el-input__inner {
  border: none;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: transparent;
  padding: 10px;
  min-width: 110px;
  max-width: 132px;
  overflow: hidden;
  margin-right: 4px;
  background: transparent;
  color: #ffffff;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #3d94ff;
  box-sizing: border-box;
}

.class-select1 >>> .el-input__inner {
  border: none;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: transparent;
  padding: 10px;
  width: 110px;
  overflow: hidden;
  margin-right: 4px;
  background: transparent;
  color: #ffffff;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #3d94ff;
  box-sizing: border-box;
}

.class-select >>> .el-input__suffix {
  display: none;
}

.font-green {
  color: #1bef6b;
}

.gray {
  color: #c0c0c0;
}
.custom-option-group {
  width: 100%;
  display: flex;
}

.custom-option-item {
  min-width: 50%; /* 每个选项占一半宽度 */
  box-sizing: border-box;
  padding: 0 10px; /* 调整内边距以适应布局 */
}

/* 确保选项之间的间距 */
.custom-option-item + .custom-option-item {
  margin-left: 10px;
}
</style>
